import AcxSelectSingle from "components/UI/Select/BaseSelectComponents/AcxSelectSingle";
import React, { useState, useCallback } from "react";
import { ModuleService } from "services/ModuleService";
import { DataLabelingModule } from "models/LLMs/DataLabelingModule";

type DataLabelingModuleSelectorProps = Partial<
    Omit<React.ComponentPropsWithoutRef<typeof AcxSelectSingle<DataLabelingModule>>, "options">
>;

export function DataLabelingModuleSelector(
    props: DataLabelingModuleSelectorProps,
) {
    const [options, setOptions] = useState<{ id: string; name: string }[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchOptions = useCallback(async () => {
        if (isLoading || options.length > 0) return;

        try {
            setIsLoading(true);
            const service = new ModuleService();
            const modules = await service.getDataLabelingLicensedModules();
            setOptions(modules);
        } finally {
            setIsLoading(false);
        }
    }, [isLoading, options]);

    return (
        <AcxSelectSingle
            id="module"
            valueField="name"
            labelField="name"
            fullWidth
            {...props}
            isLoading={isLoading}
            options={options}
            onMenuOpen={fetchOptions}
        />
    );
}
